<main class="main">
  <fyxt-main>
    <div class="sidenav">
      <fyxt-side-bar />
    </div>
    <fyxt-chat class="d-contents" />
  </fyxt-main>
</main>
<router-outlet />
